import { CRLF2 } from "../constants/newlines";

export const parseHttpResponse = (response) => {
    const body = response
        .split(CRLF2)
        .slice(1)
        .join(CRLF2);

    return { body };
};